import React from 'react';
import '../css/MaroonTextSection.css'; // Make sure this CSS file is correctly linked

function MaroonTextSection() {
  return (
    <section className="maroon-text-section">
      <div className="container text-center py-5">
        <h1 className="stylish-header">Made with Meaning</h1> {/* Static text for header */}
        <p className="lead fw-medium">
        At Gitaami, we blend the age-old wisdom of India with modern elegance. Every product we create — from fragrances to skincare — is a love letter to your senses, crafted with care and rooted in purity.
        </p>
        
      </div>
    </section>
  );
}

export default MaroonTextSection;
